<template lang="pug">
.waiter-change-application-message-confirm-modal
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onSend")
    div(slot="modal-title")
      span {{ message }}

    .waiter-change-application-message-confirm-modal-body
      .register-body
        FormLabel(key-name="タイトル" :value="_title")
        FormLabel(key-name="本文" :value="_text")

    .waiter-change-application-message-confirm-modal-footer(slot="modal-footer" slot-scope="{ ok, cancel }")
      .buttons
        button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

/**
 * ### 変更申請受理・不受理メッセージ送信確認モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class WaiterChangeApplicationMessageConfirmModal extends Vue {
  @Prop({
    default: () => {
      return false;
    }
  })
  value!: boolean;

  @Prop({
    default: () => {
      return "";
    }
  })
  message!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  title!: string;

  @Prop({
    default: () => {
      return "";
    }
  })
  text!: string;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _title(): string {
    return this.title;
  }

  get _text(): string {
    return this.text;
  }

  /**
   * ### 送信ボタン押下処理
   *
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  public onSend(modalEvent: any): void {
    modalEvent.preventDefault();
    this.$emit("onSend");

    return;
  }
}
</script>
